/**
 * Checks if a value has a specific flag set using bitwise operations.
 * Only works correctly with bitwise flags (powers of 2).
 *
 * @param value The value to check
 * @param flag The flag to check for (must be a power of 2 for correct behavior)
 * @returns True if the flag is set in the value
 */
export default function hasFlag<T extends number>(value: T, flag: T): boolean {
	// If flag is 0, it's not a valid flag to check
	if (flag === 0) {
		return false;
	}

	return (value & flag) === flag;
}
